import { z } from "zod";
import { type HydratedUser } from "@packsize/identity-api-sdk";

export const hydratedUserSchema = z
	.object({
		id: z.string(),
		userTenants: z.array(z.object({ id: z.string() }).passthrough()),
		permissions: z.array(z.string()),
		featureFlags: z.record(z.string(), z.string()),
	})
	.passthrough();

export type HydratedUserData = HydratedUser;
